<site-header></site-header>

<ion-content>
  <div class="hero">
    <ion-row>
      <ion-col size="12" class="ion-text-center">
        <h1>Koomzo solutions</h1>
        <p>
          Specialized in cloud-based mobile-first enterprise scale apps; with a
          lean approach
        </p>
      </ion-col>
    </ion-row>
  </div>
  <ion-row class="ion-justify-content-center">
    <ion-col sizeLg="8" sizeSm="12">
      <div class="holder">
        <ion-row>
          <ion-col sizeLg="5.75">
            <div class="the-card">
              <ion-item lines="none">
                <div class="thumb flex-center" slot="start">
                  <img src="assets/icon/favicon.png" alt="" />
                </div>
                <ion-label>
                  <h1>Mobile first</h1>
                  <!-- <p class="ion-text-wrap">
                    We believe mobility is key in build modern platform. Clients
                    now access software platforms from an ever increasing range
                    of mobile terminals. Mobile terminal present a lean
                    infrastructure with multiple advantages.
                  </p> -->
                </ion-label>
              </ion-item>
            </div>
          </ion-col>
          <ion-col sizeLg="0.5"> </ion-col>
          <ion-col sizeLg="5.75">
            <div class="the-card">
              <ion-item lines="none">
                <div class="thumb flex-center" slot="start">
                  <img src="assets/icon/favicon.png" alt="" />
                </div>
                <ion-label>
                  <h1>Cloud based</h1>
                  <!-- <p class="ion-text-wrap">
                    Having serverless/lean backend with only focus on cloud
                    resource usage and optimization; weeding out any infrasture
                    ownership/ maintenace cost is key in running cost effective
                    & lean platforms
                  </p> -->
                </ion-label>
              </ion-item>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeLg="5.75">
            <div class="the-card">
              <ion-item lines="none">
                <div class="thumb flex-center" slot="start">
                  <img src="assets/icon/favicon.png" alt="" />
                </div>
                <ion-label>
                  <h1>Enterprise Scale</h1>
                  <!-- <p class="ion-text-wrap">
                    Our powerfully simple and lean platform equally adopt
                    mainstream enterprise patterns to achieve stability,
                    reliability, scalability, performance and health monitoring.
                  </p> -->
                </ion-label>
              </ion-item>
            </div>
          </ion-col>
          <ion-col sizeLg="0.5"> </ion-col>
          <ion-col sizeLg="5.75">
            <div class="the-card">
              <ion-item lines="none">
                <div class="thumb flex-center" slot="start">
                  <img src="assets/icon/favicon.png" alt="" />
                </div>
                <ion-label>
                  <h1>Intergrated</h1>
                  <!-- <p class="ion-text-wrap">
                    Our focus is ERP(<small
                      >Enterprise resource planning systems</small
                    >) and we intergrate a wide range of third party services
                    relevant for enterprise business process automation
                  </p> -->
                </ion-label>
              </ion-item>
            </div>
          </ion-col>
        </ion-row>
      </div>
    </ion-col>
  </ion-row>
</ion-content>
<!-- <ion-footer mode="md">
  <div class="container">
    <ion-row class="ion-align-items-center ion-justify-content-center">
      <ion-col size="12" class="flex al-center jc-center ion-text-center">
        <ion-button (click)="onClick()" fill="clear" mode="md">
          Terms
        </ion-button>
        |
        <ion-button (click)="onClick()" fill="clear" mode="md">
          Privacy
        </ion-button>
      </ion-col>
    </ion-row>
  </div>
</ion-footer> -->
<site-footer></site-footer>
